var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPartyArrow1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 162,
    viewBox: "0 0 146 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 39866"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 210",
    d: "M109.871 22.3853C111.362 41.4176 108.571 63.3761 94.3772 77.5029C85.3066 86.5309 69.5295 89.4873 58.1077 83.6304C47.3207 78.0989 38.7272 67.9638 41.1567 55.3425C42.4231 48.7638 46.4169 43.5779 53.5747 43.5416C64.5101 43.4862 73.7304 55.9317 76.9402 65.1359C86.9571 93.8606 79.9157 130.94 58.969 153.193",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 219",
    d: "M80.4506 145.439C75.6534 147.786 64.5389 152.805 58.4582 154.102",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 220",
    d: "M58.4532 154.1C58.6396 148.763 58.6883 136.568 57.3918 130.487",
    stroke: "#E5B422",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartyArrow1);
export default __webpack_public_path__ + "static/media/party-arrow1.88ae8033877d346c5c719fe6cc238259.svg";
export { ForwardRef as ReactComponent };